import { AfterViewInit, Component, EventEmitter, Input, input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { GinfoSpKeyDatesVm, ProjectApproval } from '../../../models/salesplan-vm';
import moment from 'moment';
import { UserLogin } from '../../../../Common/models/user.login';
import { ProjectService } from '../../../services/project.service';
import { MessageService } from '../../../services/message.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from '../../../../Common/services/storage.service';
import { UserRoleServiceService } from '../../../../shared/services/user-role-service.service';
import { KeyDatesDto } from '../../../models/project-vm';
import { UnsavedChangesService } from '../../../../unsaved-changes.service';

@Component({
  selector: 'ginfo-salesplan-keydates',
  templateUrl: './ginfo-salesplan-keydates.component.html',
  styleUrl: './ginfo-salesplan-keydates.component.css'
})
export class GinfoSpKeyDatesComponent implements AfterViewInit {
  date = new FormControl();
  resourceFulfilledDate: any;
  // minDate: Date = new Date();

  dateFormat: string | undefined;

  @Input() keyDatesInfo: GinfoSpKeyDatesVm = new GinfoSpKeyDatesVm();
  @Input() projectApproval: ProjectApproval = new ProjectApproval();
  @Input() enablePWR: boolean = false;
  @Input() disableAfterReview: boolean = false;
  @Input() isSRETeam: boolean = false;
  @Output() emitValueChanged = new EventEmitter<GinfoSpKeyDatesVm>();

  endDate: Date | null | undefined;
  selectedendDate: Date | null | undefined;
  today: Date | null | undefined;
  aprDate: Date | null | undefined;
  pwrDate: Date | null | undefined;
  uInfo: UserLogin | null | undefined;

  minDateForStartDate: Date | null | undefined;
  minDateForEndDate: Date | null | undefined;
  minDateForExecStartDate: Date | null | undefined;

  weeksToAdd: number = 2; // Default to 2 weeks

  constructor(private projectService: ProjectService,
    private msgService: MessageService,
    private ngxService: NgxUiLoaderService,
    private storageService: StorageService,
    private userRoleService: UserRoleServiceService,
    private unsavedChangesService:UnsavedChangesService
  ) { }

  async ngOnInit() {

    this.uInfo = this.storageService.getItem<UserLogin>("UserInfo");

    this.dateFormat = 'M-dd-yy';
    this.today = new Date();

    this.setInitiatedDate();

    this.setMinDateForStartDate();
    
    this.setStartDate();
    
    await this.setEndDate();
  }
  onAnyFieldValueChange(e:boolean){
    if(e){
      this.unsavedChangesService.setUnsavedChanges(true);
    }
  }

  ngAfterViewInit(): void {
  }

  setInitiatedDate() {
    if (this.keyDatesInfo!.initiatedDate) {
      this.keyDatesInfo!.initiatedDate = new Date(this.keyDatesInfo!.initiatedDate);
    } else {
      this.keyDatesInfo!.initiatedDate = new Date(); // Default to today if null
    }
    
    this.keyDatesInfo.initiatedDateStr = moment(this.keyDatesInfo.initiatedDate).format('DD-MMM-yyyy');
  }

  //Referred the same in addeditsalesplan for cloning
  setStartDate() {
    if (this.keyDatesInfo.startDate) {
    } else {
      this.keyDatesInfo.startDate = this.getFutureSunday();
    }

    const momentDate = moment(this.keyDatesInfo.startDate, 'YYYY-MM-DD').toDate();
    this.keyDatesInfo.startDate = momentDate;

    this.keyDatesInfo.startDateStr = moment(this.keyDatesInfo.startDate).format('DD-MMM-yyyy');
  }

  setMinDateForStartDate() {
    if (this.isSRETeam) {
      this.minDateForStartDate = this.keyDatesInfo.initiatedDate;
    }
    else {
      this.minDateForStartDate = this.getFutureSunday();
    }
  }

  setMinDateForEndDate(startDate: any){
    this.minDateForEndDate = startDate;
  }

  async ngOnChanges(changes: SimpleChanges) {

    if (changes['keyDatesInfo'] && this.keyDatesInfo! != null) {

      if (this.keyDatesInfo.approvedOn != null) {
        this.aprDate = new Date(this.keyDatesInfo!.approvedOn);
      }
      if (this.keyDatesInfo!.pwrDate != null) {
        this.pwrDate! = new Date(this.keyDatesInfo!.pwrDate);
        this.keyDatesInfo!.pwrDate = new Date(this.keyDatesInfo!.pwrDate!);
        this.keyDatesInfo.pwrDateStr = moment(this.keyDatesInfo!.pwrDate).format('DD-MMM-yyyy');
        this.emitValueChanged.emit(this.keyDatesInfo);
      }

      this.setInitiatedDate();

      this.setMinDateForStartDate();

      this.setStartDate();

      // Calculate the end date based on the start date
      await this.setEndDate();

      this.emitValueChanged.emit(this.keyDatesInfo);
    }
  }

  async onStartDateChange(ev: any) {
    this.keyDatesInfo.startDateStr = moment(ev).format('DD-MMM-yyyy');

    this.endDate = new Date(ev); // Clone start date
    this.endDate.setDate(this.endDate.getDate() + (7 * 2)); // Add weeksToAdd weeks
    this.keyDatesInfo.endDate = this.endDate;
    this.keyDatesInfo.endDateStr = moment(this.endDate).format('DD-MMM-yyyy');

    this.setMinDateForEndDate(ev); //For All roles
    this.unsavedChangesService.setUnsavedChanges(true);
    this.emitValueChanged.emit(this.keyDatesInfo);
  }

  async setEndDate() {
    if (this.keyDatesInfo.startDate) {
      // Clone to avoid modifying the original
      let selectedStartDate = new Date(this.keyDatesInfo.startDate);

      // Create a new Date object for adjusting
      const tWOWeeksLater = new Date(selectedStartDate);
      tWOWeeksLater.setDate(selectedStartDate.getDate() + (7 * 2)); // Adjusting the date by 14 days

      this.setMinDateForEndDate(this.keyDatesInfo.initiatedDate); //For All roles

      // Set the end date in the keyDatesInfo
      if (!this.keyDatesInfo.endDate) {
        this.keyDatesInfo.endDate = tWOWeeksLater;
      }
      const momentEndDate = moment(this.keyDatesInfo.endDate, 'YYYY-MM-DD').toDate();
      this.keyDatesInfo.endDate = momentEndDate;
      this.keyDatesInfo.endDateStr = moment(this.keyDatesInfo.endDate).format('DD-MMM-yyyy');
      this.emitValueChanged.emit(this.keyDatesInfo);
    }
  }

  onPWRDateChange(ev: any) {
    this.keyDatesInfo.pwrDate = ev;
    this.pwrDate = ev;
    this.keyDatesInfo.pwrDateStr = moment(ev).format('DD-MMM-yyyy');
    this.unsavedChangesService.setUnsavedChanges(true);
    this.emitValueChanged.emit(this.keyDatesInfo);
  }

  onEndDateChange(ev: any) {
    this.keyDatesInfo.endDate = ev;
    this.keyDatesInfo.endDateStr = moment(ev).format('DD-MMM-yyyy');
    this.unsavedChangesService.setUnsavedChanges(true);
    this.emitValueChanged.emit(this.keyDatesInfo);
  }

  getFutureSunday(): Date {
    const baseDate = this.keyDatesInfo.initiatedDate ? new Date(this.keyDatesInfo.initiatedDate) : new Date();
    const threeWeeksLater = new Date(baseDate);
    threeWeeksLater.setDate(baseDate.getDate() + 21); // Add 21 days (3 weeks)

    // Find the immediate Sunday after three weeks later
    const dayOfWeek = threeWeeksLater.getDay();
    const daysUntilSunday = (7 - dayOfWeek) % 7;
    const nextSunday = new Date(threeWeeksLater);
    nextSunday.setDate(threeWeeksLater.getDate() + daysUntilSunday);

    return nextSunday;
  }

  //// Key dates calucation after review request
  async changeKeyDatesAfterReviewRequest(headerId: number) {
    this.getFutureSundayAfterReviewRequest(headerId);
  }
  
  getFutureSundayAfterReviewRequest(headerId: number) {
    const today = new Date();
    this.keyDatesInfo.initiatedDate = today;
  
    this.setMinDateForStartDate();
    this.setStartDate();

    this.calculateEndDateAfterReviewRequest(headerId);
  }

  calculateEndDateAfterReviewRequest(headerId: number) {

    if (this.keyDatesInfo.startDate) {

      let keyDatesDto = new KeyDatesDto();
      keyDatesDto.headerId = headerId;
      keyDatesDto.startDate = this.keyDatesInfo.startDate;     
      keyDatesDto.startDateStr = moment(this.keyDatesInfo.startDate).format('DD-MMM-yyyy'); //Pass as string to fix time zone conversion issue // It saves the previous date value
      keyDatesDto.initiatedDate = this.keyDatesInfo.initiatedDate ?? undefined;
      keyDatesDto.initiatedDateStr = moment(keyDatesDto.initiatedDate).format('DD-MMM-yyyy');

      let newEndDate: Date | null | undefined;
      newEndDate = new Date(this.keyDatesInfo.startDate); // Clone start date
      newEndDate.setDate(newEndDate.getDate() + (7 * 2)); // Add weeksToAdd weeks

      const endDateOnly = this.getDateOnly(this.keyDatesInfo.endDate!);
      const newEndDateOnly = this.getDateOnly(newEndDate);

      if (this.keyDatesInfo.endDate === undefined || this.keyDatesInfo.endDate === null || endDateOnly.getTime() === newEndDateOnly.getTime()) {
        this.endDate = new Date(this.keyDatesInfo.startDate); // Clone start date
        this.endDate.setDate(this.endDate.getDate() + (7 * 2)); // Add weeksToAdd weeks

        this.keyDatesInfo.endDate = this.endDate;
        this.keyDatesInfo.endDateStr = moment(this.endDate).format('DD-MMM-yyyy');

        keyDatesDto.endDate = this.endDate ?? undefined;
        keyDatesDto.endDateStr = moment(keyDatesDto.endDate).format('DD-MMM-yyyy');
      }
      else {
        this.endDate = new Date(this.keyDatesInfo.endDate);
        this.endDate.setDate(this.endDate.getDate() + 0);

        this.keyDatesInfo.endDate = this.endDate;
        this.keyDatesInfo.endDateStr = moment(this.endDate).format('DD-MMM-yyyy');

        keyDatesDto.endDate = this.endDate ?? undefined;
        keyDatesDto.endDateStr = moment(keyDatesDto.endDate).format('DD-MMM-yyyy');
      }

      this.projectService.UpdateKeyDates(keyDatesDto).subscribe(x => {
      });
    }
  }

  getDateOnly(date: Date): Date {
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  
}